// The customer pool — the same 50 seeded customers everything else in the
// demo is keyed on (shared/catalog/customers.json; fraud-check's velocity
// table, payment's credit limits, order-service's own customer table —
// ADR 0023). Copied into the bundle at `npm run package`, same as
// products.json; the checkout "customer picker" is a dropdown over this,
// not a signup (ADR 0036).

export interface Customer {
  customerId: string;
  name: string;
  tier: string;
  creditLimit: number;
}

export async function fetchCustomers(): Promise<Customer[]> {
  const res = await fetch(`${import.meta.env.BASE_URL}customers.json`, { cache: "no-store" });
  if (!res.ok) {
    throw new Error(`customers.json ${res.status}`);
  }
  const data: unknown = await res.json();
  if (!Array.isArray(data)) {
    throw new Error("customers.json: expected an array");
  }
  return (data as Customer[]).slice().sort((a, b) => a.name.localeCompare(b.name));
}
